import $ from "jquery";

const openingHours = () => {

    const target = ".wapp-opening-hours";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };



    const exec = () => {

        const today = new Date().getDay();
        
        const days = [
            'sunday', 
            'monday', 
            'tuesday', 
            'wednesday', 
            'thursday', 
            'friday', 
            'saturday'
        ];
        
        const currentDayElement = $('.' + days[today]);
        currentDayElement.addClass('current-day');
    };

    init();
};

try {
    openingHours();
} catch (error) {
    throw Error(error);
}

